export const ORCHESTRATION_ENDPOINT = {
  CREATE_ORDER: '/order',
  SAVE_CHECKOUT: '/savecheckout',
  VALIDATE_PRODUCT_TENANT: '/validateProductTenant'
};
